;(function (window, app, $) {

    var SELECTORS = {
        TARGET: '[data-js-youtube-player]',
        PLACEHOLDER: '.youtubePlayer-placeholder',
    };

    /**
     * Embeds a YouTube video in place of a placeholder element and toggles
     * 'is-active' class on a target element corresponding to YouTube video
     * player state.
     *
     * Requires $placeholder element to be a descendent of $target element.
     * Requires $target element to have [data-yt-id] attribute with YouTube
     * video ID as the value.
     *
     * @param {Object} args - Function arguments
     * @param {string} args.youtubeId - YouTube ID for video to be embedded
     * @param {jQuery} args.$target - Target element whose classes will be toggled
     *   according to player state
     * @param {jQuery} args.$placeholder - Placeholder element to be replaced
     *   with embedded YouTube video
     */
    var embed = function embed(args) {
        var $target = args.$target;
        var $placeholder = args.$placeholder;
        var youtubeId = args.youtubeId;

        // get youtube player to do things with
        app.youtubeIframePlayerEmbedder.getPlayer($placeholder.get(0), youtubeId)
            .then(function (player) {
                // queue playback on click, in case player isn't ready yet
                $target.one('click', function (event) {
                    event.preventDefault();
                    player.addEventListener('onReady', function onPlayerReady() {
                        player.playVideo();
                    });
                });
                // setup playback on click
                player.addEventListener('onReady', function onPlayerReady() {
                    $target.on('click', function (event) {
                        event.preventDefault();
                        player.playVideo();
                    });
                });
                // state changes
                player.addEventListener('onStateChange', function onStateChange(event) {
                    switch (event.data) {
                        case YT.PlayerState.PLAYING:
                        case YT.PlayerState.BUFFERING:
                            $target.addClass('is-active');
                            break;
                        case YT.PlayerState.ENDED:
                            $target.removeClass('is-active');
                            app.util.fullscreenExit();
                            break;
                        default:
                            break;
                    }
                });
            });
    };

    /**
     * Globally embed based using default selectors.
     */
    var init = function init() {
        $target = $(SELECTORS.TARGET);
        $target.each(function (i, target) {
            var $tar = $(target);
            $placeholder = $tar.find(SELECTORS.PLACEHOLDER);
            embed({
                youtubeId: $tar.data('yt-id'),
                '$target': $tar,
                '$placeholder': $placeholder,
            });
        });
    };

    app.extend({
        youtubePlayer: {
            embed: embed,
            init: init,
        },
    });

})(window, window.app, window.jQuery);
